export const USERLIST = "admin/user/list";
export const USERDETAIL = "admin/user/detail";
export const USER_EVENT = "admin/event";
export const USER_SUB_EVENTS = "admin/event/subEvents";

export const USER_TASKS = "admin/event/tasks";
export const USER_DASHBOARD = "admin/user/dashboard";

export const POSTS = "admin/user/post";

export const JOB_CATEGORY_LIST = "admin/job/category";

export const SERVICE_CATEGORY_LIST = "admin/service/category";

export const JOB_POSTING_LIST = "admin/job";

export const FLAG_POSTING_LIST = "admin/report";

export const ACTIVE_FLAG_POSTING_LIST = "admin/report/post/active";

export const SERVICE_POSTING_LIST = "admin/service";

export const JOB_DETAILS = "admin/job/detail";

export const SERVICE_DETAILS = "admin/service/detail";

export const BLOCK_USER = "admin/user/blockUnblock";

export const PRICE = "admin/job-settings";

export const DASHBOARD = "admin/dashboard";

export const FAQ = "admin/user/faqs";

export const NEWUSERS = "admin/user/list";
export const EVENTS = "admin/user/events";

export const SUBSCRIPTIONSTATUS = "admin/user/subscription";
export const NEW_WEDDING_SUBSCRIPTIONSTATUS = "admin/user/newWedding/subscription";

export const TEMPALTES = "admin/event/template";

export const SUBSCRIPTION = "admin/user/subscriptions";
export const COMBINEDPACKAGE = "admin/user/combinedPackages";
export const PLANCREATION = "/admin/user/partner/subscriptions"


export const USER_COHOST = "/admin/user/cohost";
export const USER_GUESTS = "/admin/user/guest";
export const USER_EVENT_GUESTS = "/admin/event/guest";


export const EVENT_LISTING_TASKS = "/admin/event/tasks";

export const POLICY = "/admin/policy";

export const ADD_COHOSTS = "/admin/user/cohost";

export const DELETE_USERS = "/admin/user";

export const USER_GRAPH = "/admin/graph/user";
export const EVENT_GRAPH = "admin/graph/events";
export const REVENUE_GRAPH = "admin/graph/subscription";

export const PHOTO_GALLERY = "/admin/user/gallery";
export const UPLOADIMAGE = "/user/profile/uploadImage"
export const REQUEST_PLAN_CHANGE = "admin/user/updateSubscription"
export const GET_PARTNER = "/admin/partner/getPartners"
export const PARTNER_CRUD = "/admin/partner"
export const UPDATE_PARTNER = "/admin/partner/approved"
export const GET_PARTNER_STATS = "/admin/partner/stats/dashboard"
export const GET_PARTNER_ANALYTICS = "/admin/partner/partnerAnalytics"
export const GET_PARTNER_REVENUE_GRAPH = "/admin/partner/graph"
export const GET_PACKAGE_REVENUE_GRAPH = "/admin/partner/graphs/packageRevenue"
export const PACKAGE_STATS = "/admin/partner/subscribtionStats"
export const PARTNER_HOST = "/admin/partner/hosts"
export const UPDATE_PARTNER_WHATSAPP_LIMIT = "/admin/partner/whatsappMessageLimit";
export const ASSIGN_PARTNER_PLAN = "/admin/partner/assignPlan";
export const WHATSAPP_PACKAGE = "admin/partner/whatsappPlans"
export const GET_WHATSAPP_PACKAGE_REVENUE_GRAPH = "/admin/partner/graphs/whatsappPlanRevenue";
export const GET_TOTAL_REVENUE_GRAPH = "/admin/partner/graphs/allRevenue";
export const GET_ACQUISITION_SOURCE_GRAPH = "/admin/partner/graphs/aquisitionSource";
export const GET_HOST_CREATED_GRAPH = "/admin/partner/graph/hostCreated";
export const WHATAPP_ASSIGN = "admin/partner/assignWhatsappPlan"
export const GET_PARTNER_NOTIFICATIONS = "/admin/partner/notifications";
export const MARK_NOTIFICATION_READ = "/admin/partner/notifications/read";
export const GET_INACTIVE_PARTNERS_NO_LOGIN = "/admin/partner/inactive/noLogin";
export const GET_INACTIVE_PARTNERS_NO_WEDDING = "/admin/partner/inactive/noWedding";
export const HARD_DELETE_PARTNER = "/admin/partner/hardDelete";
export const HARD_DELETE_USER = "/admin/user/hardDelete";
export const GET_SUBSCRIPTION_STATS = "/admin/partner/subscription/stats";
export const NEW_WEDDING_REQUEST = "admin/user/newWeddingRequest";
export const HOST_WEDDINGS = "/admin/user/detail/weddings"
export const ASSIGNPLAN = "admin/subscription/plan"
